import React from 'react'
import { AutocompleteInput, TextInput } from 'react-admin'
import { countries } from 'services/cfg/countries'
import { countrySwitchFC } from 'services/geo-management'
import { CustomFormProps } from 'types/common'
import PecSdiVatForm from 'ui-shared/FormGeoExtensions/PecSdiVatForm'
import { KSimpleForm } from 'ui-shared/WrappedInputs/KSimpleForm'

const BusinessFormITAExt = countrySwitchFC({
  IT: PecSdiVatForm,
})

const CustomerFormCommon: React.FC<CustomFormProps> = (props) => {
  const { children } = props
  return (
    <KSimpleForm {...props}>
      <TextInput source="name" label="form.fields.name" />
      <TextInput
        source="responsibleFullName"
        label="form.fields.responsibleFullName"
      />
      <AutocompleteInput
        source="country"
        choices={[...countries]}
        optionText={'countryName'}
        optionValue={'code'}
      />
      <TextInput
        source="responsibleEmail"
        label="form.fields.responsibleEmail"
      />
      <TextInput
        source="headQuarters"
        label="form.fields.businessHeadQuarter"
      />
      <TextInput
        source="organizationNumber"
        label="form.fields.organizationNumber"
      />
      <BusinessFormITAExt />
      {children}
    </KSimpleForm>
  )
}

export default CustomerFormCommon
